/**
 * Reverb (Pusher) connection options for Laravel Echo.
 */
export function getReverbConnectionOptions() {
  const useViteReverbProxy =
    import.meta.env.DEV && import.meta.env.MODE === "be"

  if (useViteReverbProxy) {
    const scheme = window.location.protocol === "https:" ? "https" : "http"
    const port = Number(window.location.port) || (scheme === "https" ? 443 : 80)

    return {
      wsHost: window.location.hostname,
      wsPort: port,
      wssPort: port,
      forceTLS: scheme === "https"
    }
  }

  const scheme = import.meta.env.VITE_REVERB_SCHEME ?? "http"
  const wsHost = (
    import.meta.env.VITE_REVERB_HOST ??
    import.meta.env.VITE_WS_HOST ??
    "localhost"
  ).split(":")[0]

  return {
    wsHost,
    wsPort: import.meta.env.VITE_REVERB_PORT,
    wssPort: import.meta.env.VITE_REVERB_PORT,
    forceTLS: scheme === "https"
  }
}
